<div class="modal1Main" [ngClass]="(isMac)?'macOS':'otherOS'">
  <div class="modalHeader">
    <span class="title">Swap Players</span>
    <button class="closepop float-right" mat-dialog-close><i class="zmdi zmdi-close"></i></button>
  </div>
  <div class="body">
    <div class="filter-part">
      <div class="rosterPositions scrollTable" *ngIf="searchMode" style="width: 69%;">
        <div class="rosterPosition"
          style="display: inline-block;background-color: rgb(46, 142, 113); color: rgb(255, 255, 255); border: 2px solid rgb(46, 142, 113);"
          (click)="clickOnSearch()" matTooltip="Search Players" matTooltipPosition="above"><i class="fas fa-search"
            matPrefix></i></div>

        <ng-container *ngFor="let position of rosterPositions">
          <div class="rosterPosition"
            [ngStyle]="curFilter.pname == position.pname || curFilter.pname == 'All' ? position.activeClass : position.inactiveClass"
            (click)="setFilter(position)">{{position.pname}}</div>
        </ng-container>
      </div>
      <div *ngIf="!searchMode" class="searchContainer" style="width: 69%;">
        <mat-form-field style="width:100%;">
          <mat-label>Search</mat-label>
          <input matInput placeholder="Search Player Name" #searchInput (ngModelChange)="updateSearch($event)"
            [ngModel]="curSearch" cdkFocusInitial>
          <button matSuffix mat-icon-button aria-label="Close" (click)="clickOnSearch();">
            <mat-icon matTooltip="Close" matTooltipPosition="above">X</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div style="width:29%;">
        <mat-form-field class="team">
          <mat-select [value]="curTeam" placeholder="Select Team" (selectionChange)="updateTeam($event)">
            <mat-option *ngFor="let team of teamData" [value]='team.abbr'>{{team.loc}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <ng-container>
      <div class="heading">
        <div class="playerinfo first">
          <span class="position">{{ curplayer.pick_rp }}</span>
          <div class="headshot" [ngStyle]="{'background-image':'url(\''+playerURL+curplayer.pic+'\')'}"></div>
          <div class="player-fn">
            {{ curplayer.fn }} {{ curplayer.ln }}
            <div class="player-ln">
              <span>{{ curplayer.tn | uppercase }}</span>
            </div>
          </div>
          <div class="projected">{{ curplayer.projFpts | number:'1.2-2'}}</div>
        </div>
        <div class="swap-out">
          <img src="assets/images/abc.gif">
          <!-- <img [src]="assetsURL+'default/images/swap_icon.svg'"> -->
        </div>
        <div class="playerinfo second">
          <span class="position">{{newplayer.id>0?newplayer.pn:''}}</span>
          <div class="headshot"
            [ngStyle]="{'background-image':'url(\''+playerURL+(newplayer.id>0?newplayer.pp:'default.png')+'\')'}"></div>
          <div class="player-fn">
            {{newplayer.id>0?newplayer.fn:'Select'}} {{newplayer.id>0?newplayer.ln:'Player'}}
            <div class="player-ln">
              <span>{{newplayer.id>0?newplayer.tn:'' | uppercase }}</span>
            </div>
          </div>
          <div class="projected">{{(newplayer.id>0?newplayer.prj:0) | number:'1.2-2'}}</div>
        </div>
      </div>
      <div class="confirm" *ngIf="newplayer.id>0">
        <mat-progress-bar *ngIf="showLoader" class="loadingBar" mode="buffer"></mat-progress-bar>
        <ng-container *ngIf="!showLoader">
          <a (click)="confirmSwap(row)" mat-raised-button color="primary" class="button">
            Confirm</a>
          <a (click)="cancelSwap(row)" mat-stroked-button class="button">
            Cancel</a>
        </ng-container>
      </div>
      <div class="bottom-part scrollTable">
        <div id="overlay" *ngIf="newplayer.id>0" [ngStyle]="{'height':'65vh'}">

        </div>
        <table class="table statTable">
          <thead class="thead">
            <tr>
              <th class="label"></th>
              <th class="label playername">Player Name</th>
              <th class="label">Swap</th>
              <th class="label">OPP</th>
              <th class="label">Proj</th>
              <th class="label">Avg</th>
            </tr>
          </thead>
          <tbody class="table">
            <tr *ngFor="let row of filteredPlayers; let i = index">
              <ng-container>
                <td class="label col posname" [ngStyle]="{'color':row.colorcode?row.colorcode:''}">{{ row.pn }}</td>
                <td class="col playername" (click)="openPlayerInfoBox(row,row.id)">
                  <div class="headshot" [ngStyle]="{'background-image':'url(\''+playerURL+row.pp+'\')'}"></div>
                  <div class="name">{{row.fn}} {{row.ln}}</div>
                </td>
                <td class="col">
                  <a (click)="selectNewPlayerForSwap(row)" mat-stroked-button class="button"
                    *ngIf="row.swap_cnf == 1"><i class="fas fa-exchange-alt icon"></i>
                    Swap {{row.lgm}}</a>
                </td>
                <td class="col status">
                  {{row.opn | uppercase}}
                </td>
                <td class="col proj">
                  {{ ((row.prj!= null) ? row.prj : col) | number:'1.2-2' }}
                </td>
                <td class="col fpts">
                  {{ ((row.avg!= null) ? row.avg : col) | number:'1.0-2'}}
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>
        <div *ngIf="playerData== ''" class="text-center minHeight150">No record found</div>
      </div>
    </ng-container>
  </div>
</div>